import { render } from "./print-purchase-receipt.vue?vue&type=template&id=c625fd5c"
import script from "./print-purchase-receipt.vue?vue&type=script&lang=js"
export * from "./print-purchase-receipt.vue?vue&type=script&lang=js"

import "./print-purchase-receipt.vue?vue&type=style&index=0&id=c625fd5c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__